import { Header } from '@/features/shared/components/Headers/Header'
import { Footer } from '@/features/shared/components/Footers/Footer'
import { type NextPageWithLayout } from '@/pages/_app'
import { type ComponentProps } from 'react'
import { ActivityPunchCardFab } from '@/features/shop/components/CategorySubNav/ActivityPunchCardFab'
import { attachLayout } from '@/features/shared/components/Headers/Layouts/attachLayout'

type Props = ComponentProps<typeof Header>

export function withHeaderLayout<P extends object>(
  Component: NextPageWithLayout<P>,
  {
    suppressFooter,
    showActivityPunchCardButton,
    ...restProps
  }: Props & {
    suppressFooter?: boolean
    showActivityPunchCardButton?: boolean
  } = {},
) {
  return attachLayout(Component, (page) => (
    <>
      <Header {...restProps} />
      {!!showActivityPunchCardButton && <ActivityPunchCardFab />}
      {page}
      {!suppressFooter && <Footer />}
    </>
  ))
}
